module.exports = __webpack_public_path__ + "static/people_img25-246e3bcaad71db7875ec0370d139c97e.png";